<rlst-modal [header]="'Sort Cards'" (closeModal)="close()">
  <div class="content" [formGroup]="customizeForm">
    <p class="sort-title mb-0 mt-2">Select your sorting preferences</p>
    <div role="radiogroup" class="custom-control-stacked">
      <label class="custom-control p-0 mt-4 custom-radio flex-wrap align-items-center">
        <input value=""
               formControlName="sortField"
               name="sortField"
               tabindex="0"
               type="radio"
               class="custom-control-input radio-primary">
        <span class="custom-control-indicator p-0 mr-0"></span>
        <span class="custom-control-description pl-2">Default Order</span>
      </label>
      <label *ngFor="let attribute of (sortAttributes$ | async)"
             class="custom-control p-0 mt-4 custom-radio flex-wrap align-items-center">
        <input [value]="attribute.fieldCode"
               formControlName="sortField"
               name="sortField"
               tabindex="0"
               type="radio"
               class="custom-control-input radio-primary">
        <span class="custom-control-indicator p-0 mr-0"></span>
        <span class="custom-control-description pl-2">By {{attribute.label}}</span>
        <span class="additional-controls w-100">
          <rlst-toggle class="mt-3 ml-4"
                       formControlName="sortOrder"
                       [defaultOption]="getDefaultOption(attribute.dataType)"
                       [switchedOption]="getSwitchedOption(attribute.dataType)">
          </rlst-toggle>
        </span>
      </label>
    </div>
    <div formArrayName="allowedStatuses" class="group-section mt-4 pt-2 d-flex flex-column">
      <label *ngFor="let status of allowedStatuses.controls; let i = index;"
             class="custom-control custom-checkbox att-list__label align-items-center pb-0">
        <input type="checkbox"
               [formControlName]="i"
               (change)="toggleStatus($event, i)"
               class="custom-control-input checkbox-default">
        <span class="custom-control-indicator"></span>
        <span class="mls-status ml-2" [ngClass]="ALLOWED_STATUSES[i].class"></span>
        <span class="pl-2">{{ALLOWED_STATUSES[i].label}}</span>
      </label>
    </div>
    <div class="group-section mt-4 pt-2 pb-3">
      <label class="custom-control custom-checkbox att-list__label align-items-center pb-0">
        <input type="checkbox" formControlName="showOnlyWithPhoto" class="custom-control-input checkbox-default">
        <span class="custom-control-indicator"></span>
        <span class="fas fa-camera ml-2"></span>
        <span class="pl-2">With photo only</span>
      </label>
    </div>
  </div>
  <div mat-dialog-actions class="actions-panel actions-panel__shadow">
    <div class="flex-spacer"></div>
    <button (click)="close()" class="btn-custom btn-custom-outline-blue-dark cancel-button">Cancel</button>
    <button class="btn-custom btn-custom-blue-dark" (click)="apply()">Apply</button>
  </div>
</rlst-modal>
